module.exports = "/images/update.svg";